module.exports = __webpack_public_path__ + "img/ISO1png.864fd8ab.png";